import gql from 'graphql-tag';

const UPDATE_CREDENTIAL = gql`
    mutation($id: ID!, $input:LoginUpdateInput!){
        loginUpdate(id: $id,input:$input){
            username,
        }
    }
`

const CHECK_USERNAME = gql`
    query find($id: ID, $username: String!){
        checkUsername(id : $id, username : $username){
            uuid,
            username
        }
    }
`;

export {UPDATE_CREDENTIAL, CHECK_USERNAME};
